import { useQuery } from '@apollo/client';
import { GET_AIMO_PLUS_ELIGIBILITY } from 'graphql/queries/getAimoPlusEligibility';
import { Query } from 'types/generatedSchemaTypes';

export const useAimoPlusEligibility = ({
  isLoggedIn,
  aimoPlusSubscriber,
}: {
  isLoggedIn: boolean;
  aimoPlusSubscriber: boolean;
}) => {
  const shouldSkip = !isLoggedIn || aimoPlusSubscriber;

  const { data, loading } = useQuery<Pick<Query, 'readAimoPlusEligibility'>>(
    GET_AIMO_PLUS_ELIGIBILITY,
    {
      skip: shouldSkip,
      fetchPolicy: 'cache-and-network',
    }
  );

  return {
    isEligible: data?.readAimoPlusEligibility === true,
    loading: shouldSkip ? false : loading && data === undefined,
  };
};
